import { Spinner } from "reactstrap";
import React, { useState } from "react";
import { Download } from "react-feather";

import { TableButton } from "components/TableButton";

export const GetBestPrice = ({ getBestPriceHandler }) => {
  return <TableButton Icon={Download} onClick={getBestPriceHandler} />;
};
